import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ChemEng = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.199 15.05c-2.302-2.3-6.206-2.3-8.508 0-.9.9-1.501 2.1-1.701 3.3h-2.402c-.3-1.9-1.101-3.8-2.602-5.2-1.502-1.5-3.303-2.3-5.105-2.6v-3.8c.5-.2 1.001-.4 1.401-.8 1.402-1.4 1.402-3.6 0-4.9-1.4-1.4-3.603-1.4-4.904 0-1.4 1.4-1.4 3.6 0 4.9.5.5 1.001.8 1.602.9v3.7c-2.202.1-4.304 1-5.905 2.7-1.802 1.8-2.703 4.1-2.703 6.4H7.87c-.2-.7-.5-1.4-1.1-2-1.602-1.6-4.104-1.6-5.605 0-1.501 1.6-1.602 4.1 0 5.7 1.601 1.6 4.103 1.6 5.605 0 .5-.5.8-1.1 1-1.8h3.804c.3 1.7 1.2 3.4 2.502 4.7 1.1 1.1 2.402 1.8 3.703 2.2v2.4c-1.401.2-2.702.8-3.703 1.9-2.602 2.6-2.602 6.7 0 9.3 2.602 2.6 6.705 2.6 9.308 0 2.602-2.6 2.602-6.7 0-9.3-1.001-1-2.402-1.7-3.704-1.9v-2c2.302.2 4.604-.4 6.506-1.9l5.204 5.2c-.2.5-.4 1-.4 1.6 0 1.9 1.601 3.5 3.503 3.5 1.902 0 3.503-1.6 3.503-3.5s-1.601-3.5-3.503-3.5c-.7 0-1.301.2-1.802.5l-5.104-5.1c1.201-1.4 2.002-3.3 2.102-5.2h2.302c.2 1.2.8 2.4 1.701 3.3 2.402 2.3 6.206 2.3 8.508 0 2.401-2.5 2.401-6.3 0-8.7Zm-20.117 19c1.801 1.8 1.801 4.8 0 6.7a4.54 4.54 0 0 1-6.606 0c-1.802-1.8-1.802-4.8 0-6.7.9-.9 2.102-1.4 3.303-1.4 1.2 0 2.402.5 3.302 1.4Zm-1.502-7.1c-4.003 0-7.306-3.3-7.306-7.3s3.303-7.3 7.306-7.3c4.004 0 7.306 3.3 7.306 7.3s-3.302 7.3-7.306 7.3Zm20.317-4.7c-1.601 1.6-4.203 1.6-5.905 0-.8-.8-1.2-1.9-1.2-2.9s.4-2.1 1.2-3c1.602-1.6 4.204-1.6 5.905 0 1.602 1.7 1.602 4.3 0 5.9Z"
  }));
});
ChemEng.displayName = 'ChemEng';
ChemEng.defaultProps = {
  'aria-label': 'ChemEng'
};
export default ChemEng;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/ChemEng.js
// module id = 2989
// module chunks = 11